import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { PackageUsage, useGetAccountUsage } from 'Features/accountSettings/api/getAccountUsage'
import {
  DataUsageWrapper,
  DataUsageTitle,
  LoaderContainer,
  ProductsWrapper,
} from './DataUsage.styled'
import { LoadingIcon } from '@clickcease/cc-client-components-lib'
import {} from '../CurrentPlanDetails/CurrentPlanDetails.styled'
import { DataUsageProductCard } from '../DataUsageProductCard/DataUsageProductCard'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'

export const DataUsage = () => {
  const { data: plansDetails } = useGetPlansDetails()
  const { data: accountUsage, isFetching } = useGetAccountUsage()
  const { t } = useTranslation('accountSettings')

  const plansInUse = useMemo(
    () => plansDetails?.plans?.map((plan) => plan.product),
    [plansDetails?.plans]
  )

  return (
    <DataUsageWrapper>
      {!!accountUsage && plansInUse?.length && (
        <>
          <DataUsageTitle>{t('data_usage.title')}</DataUsageTitle>
          <ProductsWrapper>
            {accountUsage &&
              Array.isArray(accountUsage) &&
              accountUsage.map((product: PackageUsage) =>
                plansInUse?.includes(product.product) ? (
                  <DataUsageProductCard item={product} key={product.product} />
                ) : null
              )}
          </ProductsWrapper>
        </>
      )}
      {isFetching && (
        <LoaderContainer>
          <LoadingIcon />
        </LoaderContainer>
      )}
    </DataUsageWrapper>
  )
}
